import { generatePath } from 'react-router-dom';
import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { ShipStation } from 'types';
import { addParamsToUrl } from 'utils/query';

import { apiQuery } from '../../query';

import {
  Store,
  ConfigRequest,
  StoresRequest,
  ResendNotificationsRequest,
  ResendNotificationsResponse,
} from './types';

const tagTypes = ['shipStation'];

export const shipStationApi = createApi({
  tagTypes,
  baseQuery: apiQuery,
  reducerPath: 'shipStationApi',
  endpoints: (build) => ({
    companyConfig: build.query<boolean, void>({
      providesTags: tagTypes,
      query: () => ({
        method: 'get',
        url: URL.SHIP_STATION_CONFIG,
      }),
    }),

    removeConfig: build.mutation<ShipStation, void>({
      invalidatesTags: tagTypes,
      query: () => ({
        method: 'delete',
        url: URL.SHIP_STATION_CONFIG,
      }),
    }),

    stores: build.query<Store[], StoresRequest>({
      providesTags: tagTypes,
      query: (data) => ({
        method: 'get',
        url: addParamsToUrl(URL.SHIP_STATION_STORES, data),
      }),
    }),

    config: build.mutation<ShipStation, ConfigRequest>({
      invalidatesTags: tagTypes,
      query: (data) => ({
        data,
        method: 'post',
        url: URL.SHIP_STATION_CONFIG,
      }),
    }),

    resendNotifications: build.mutation<
      ResendNotificationsResponse,
      ResendNotificationsRequest
    >({
      invalidatesTags: tagTypes,
      query: ({ id, ...data }) => ({
        data,
        method: 'post',
        url: generatePath(URL.SHIP_STATION_RESEND_NOTIFICATIONS, { id }),
      }),
    }),
  }),
});

export const {
  useStoresQuery,
  useConfigMutation,
  useLazyStoresQuery,
  useCompanyConfigQuery,
  useRemoveConfigMutation,
  useResendNotificationsMutation,
} = shipStationApi;
